module.exports = __webpack_public_path__ + "img/img-line.d7a924cc.png";